/* eslint-disable @next/next/no-img-element */
/* eslint-disable @typescript-eslint/no-explicit-any */
"use client"

import { useState, useEffect } from "react"

interface ImageWithSkeletonProps {
  src: string
  alt?: string
  initialPic: string
  [key: string]: any
}

const ImageWithSkeleton = ({
  src,
  alt = "initial image",
  initialPic,
  ...props
}: ImageWithSkeletonProps) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [isClient, setIsClient] = useState(false)

  // クライアントサイドでのみ状態を変更
  useEffect(() => {
    setIsClient(true)
  }, [])

  return (
    <>
      {isClient && !isLoaded && (
        <img src={initialPic} alt={alt} className="opacity-50" {...props} />
      )}
      {isClient && (
        <img
          src={src || initialPic} // src に初期画像をフォールバックとして使用
          alt={alt}
          onLoad={() => setIsLoaded(true)}
          className={`transition-opacity duration-500 ${isLoaded ? "opacity-100" : "opacity-0"}`}
          {...props}
        />
      )}
    </>
  )
}

export default ImageWithSkeleton
